module.exports = "pegasus/assets/fake-template.png";